import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contact from './components/pages/Contact';
import Aboutus from './components/pages/Aboutus';
import Studentpage from './components/pages/Studentpage';
import ExportExcel from './components/pages/ExportExcel';
import Printpage from './components/pages/Printpage';
import Gallery from './components/pages/Gallery';
import Excel from './components/pages/Excel';
function App() {
  return (
    
     <Router>

      <div>



        <Routes>


          <Route axact path="/" element={<Home />} />
            <Route axact path="/contact-us" element={<Contact/>} />
                        <Route axact path="/Aboutus" element={<Aboutus/>} />
                             <Route axact path="/StudentFrom" element={<Studentpage/>} />
                                 <Route axact path="/ExportExcel" element={<ExportExcel/>} />
                          <Route axact path="/PrintApplication" element={<Printpage/>} />
                          <Route axact path="/gallery" element={<Gallery/>} />
                            <Route axact path="/_____Excel___secret" element={<Excel/>} />



        
   </Routes>
        <Footer />

      </div>

    </Router>
   
  
  );
}

export default App;
